"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var DateTime = require('react-datetime');
/**
 * Display datepicker for the selection of date
 *
 * If props are not defined, it will show an empty string.
 */
exports.AcDatePicker = function (props) {
    var float = props.float;
    return (react_1.default.createElement("span", { className: "ac-date-picker " + (!float ? 'ac-date-picker-fixed' : '') },
        react_1.default.createElement(DateTime, __assign({ locale: "ja" }, props))));
};
exports.AcDatePicker.defaultProps = {
    float: true,
};
exports.AcDatePicker.displayName = 'AcDatePicker';
//# sourceMappingURL=AcDatePicker.js.map